import { render, staticRenderFns } from "./AdminBaseLogs.vue?vue&type=template&id=a67394d6"
import script from "./AdminBaseLogs.vue?vue&type=script&lang=js"
export * from "./AdminBaseLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports